import { render, staticRenderFns } from "./new-accommodation.vue?vue&type=template&id=a269192e&"
import script from "./new-accommodation.vue?vue&type=script&lang=ts&"
export * from "./new-accommodation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./new-accommodation.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports